import { render, staticRenderFns } from "./worker.vue?vue&type=template&id=17de0b2c&"
import script from "./worker.vue?vue&type=script&lang=js&"
export * from "./worker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports